import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {GetAnalysisScratchFile} from 'analysis-tool/AnalysisTypes';
import {MaybeRenderWithSignedURL} from 'external-files/SignedExtFileURLProxy';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

interface ExternalFileImageProps {
  scratchFile: GetAnalysisScratchFile;
}

/** @package */
export default function ExternalFileImage(props: ExternalFileImageProps): JSX.Element {
  return (
    <MaybeRenderWithSignedURL
      externalFileId={props.scratchFile.externalFileId}
      url={props.scratchFile.downloadUrl!}
      renderWithSignedURL={(signedURL) => {
        if (signedURL === undefined) {
          return <CenteredHorizontalThrobber />;
        } else if (signedURL == null) {
          return <InlineBanner bannerType={InlineBannerType.ERROR} text="Error loading image." />;
        } else {
          return (
            <div className={css(styles.wrapper)}>
              <img className={css(styles.image)} src={signedURL} />
            </div>
          );
        }
      }}
      owningEntityApiId={props.scratchFile.id}
    />
  );
}

const styles = StyleSheet.create({
  wrapper: {
    textAlign: 'center',
    height: 'fill-available',
  },
  image: {
    maxWidth: '100%',
    maxHeight: '100%',
  },
});
